import { render } from "./OnboardingQuiz.vue?vue&type=template&id=3016e067"
import script from "./OnboardingQuiz.vue?vue&type=script&lang=js"
export * from "./OnboardingQuiz.vue?vue&type=script&lang=js"

import "./OnboardingQuiz.vue?vue&type=style&index=0&id=3016e067&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__